import React, {useState} from 'react';
import {Button, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import StudentSimpleRow from "../Tables/StudentSimple";
import Row from "reactstrap/es/Row";
import CardHeader from "reactstrap/es/CardHeader";
import {RotateCircleLoading} from "react-loadingg";
import StudentApiService from "../../api/student-api-service";
import ClientSearchTableRow from "../Tables/ClientSearchTableRow";

let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);

const StudentSearch = (props) => {
    const [search_in_progress, setSearchState] = useState(false);
    const [show_loader, setShowLoader] = useState(false);
    const [search_results, setSearchResults] = useState([]);

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
    }

    const handleSearchChange = (event) => {
        let searchValue = event.target.value;

        setSearchState(searchValue.length > 1);
        search(searchValue)
    };

    const addStudent = (e, clientId) => {
        e.preventDefault();

        const client = search_results.find(it => it.id === clientId);

        setShowLoader(false);
        setSearchState(false);
        setSearchResults([]);
        props.addStudent(client);
    };

    const removeStudent = (e, client) => {
        e.preventDefault();
        props.removeStudentFromClassType(client);
    };

    const closeSearch = (e) => {
        e.preventDefault();

        setSearchState(false);
    };

    const renderSearchResults = () => {
        return (search_results || []).map((student, index) => {
            return (
                <ClientSearchTableRow client={student} key={student.id} addToClass={addStudent}/>
            )
        })
    };

    const renderTableData = () => {
        return props.students
            .map((student, index) => {
                return (
                    <StudentSimpleRow client={student} key={student.id} deleteClient={props.removeStudentFromClassType}
                    />
                )
            })
    };

    const search = (searchValue) => {
        setShowLoader(true);

        StudentApiService.search(searchValue)
            .then(res => {
                setSearchResults(res.students);
                setShowLoader(false)
            })
            .catch(function (error) {
                console.log(error.toJSON());
            });
    };

    localize();
    return (
        <>
            <FormGroup className="mb-0">
                <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="fas fa-search"/>
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input
                        //value={state.searchValue}
                        onChange={e => handleSearchChange(e)}
                        placeholder={studentStrings.search_client} type="text"/>
                </InputGroup>
            </FormGroup>

            {/*Search results*/}
            {search_in_progress &&
            <Row>
                <Col xl="12">
                    <CardHeader className="border-0 mt-2">
                        <Row className="align-items-center">
                            <div className="col-lg-10">
                                <h5 className="mb-0">{commonStrings.search_results}</h5>
                            </div>
                            <div className="col-lg-2 text-right">
                                {show_loader ?
                                    (<RotateCircleLoading color="#5d75b6"/>)

                                    :

                                    (<Button
                                        color="warning"
                                        onClick={e => closeSearch(e)}
                                        size="sm"
                                    >
                                        {commonStrings.close}
                                    </Button>)}
                            </div>
                        </Row>
                    </CardHeader>

                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-dark">
                        <tr>
                            <th scope="col">{studentStrings.select_client}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {renderSearchResults()}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            }

            {/*Existing students*/}
            {!search_in_progress &&
            <Row>
                <Col className="mb-5 mb-xl-0"
                     xl="12">
                    <Table
                        className="align-items-center table-dark table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-dark">
                        <tr>
                            <th scope="col"/>
                            <th scope="col"/>
                            <th scope="col"/>
                        </tr>
                        </thead>
                        <tbody>
                        {renderTableData()}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            }
        </>
    );
};

export default StudentSearch;